import QCXFormStepWizard from '../../shared-components/form-step-wizard/QCXFormStepWizard';
import QCXSelectManyClientDocumentsTable from './QCXSelectManyClientDocumentsTable';

export default function QCXClienteDocumentosForm({
    list = [],
    isConsult,
    title,
    filterProp,
    filterPropGetter,
    columns,
    handleSubmit,
    handleChange,
    controlComponentProps,
    model,
    ...restProps
}) {
    return (
        <QCXFormStepWizard
            onSubmit={handleSubmit}
            controlComponentProps={controlComponentProps}
            {...restProps}
        >
            {() => (
                <QCXSelectManyClientDocumentsTable
                    title={title}
                    columns={columns}
                    filterProp={filterProp}
                    selected={list}
                    isConsult={isConsult}
                    handleChange={handleChange}
                    model={model}
                />
            )}
        </QCXFormStepWizard>
    );
}